import React, { useState, useEffect } from "react";
import { useAppContext } from "../context/AppContext";

import {
  Typography,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  Divider,
  Button,
  Tooltip,
  Fade,
} from "@mui/material";
import { Menu as MenuIcon, Person as PersonIcon } from "@mui/icons-material";
import { API_URL } from "../helpers/api_helper";
import { useLocation, useNavigate } from "react-router-dom";
import QuestionMarkRoundedIcon from "@mui/icons-material/QuestionMarkRounded";

import Person from "../assets/Person.svg";

import Logo from "../assets/logo_2.svg";
import LogoMobile from "../assets/logo-white.webp";

// import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import { Box } from "@mui/system";

const roleRoutes = {
  physician: {
    profile: "/physician/profile",
    changePassword: "/physician/account",
  },
  admin: {
    profile: "/admin/profile",
    changePassword: "/admin/account", // if exists
  },
  patient: {
    profile: "/profile",
    changePassword: "/account",
  },
  facilities: {
    profile: "/facilities/profile",
    changePassword: "/facilities/account",
  },
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isPhysician = location.pathname.startsWith("/physician");
  const isAdmin = location.pathname.startsWith("/admin");
  const isFacilities = location.pathname.startsWith("/facilities");
  const isPatient = !isPhysician && !isAdmin && !isFacilities;

  const role = isPhysician
    ? "physician"
    : isAdmin
      ? "admin"
      : isFacilities
        ? "facilities"
        : "patient";

  const {
    userData,
    isMobile,
    isSmallMobile,
    drawerOpen,
    setDrawerOpen,
    profileMenuAnchor,
    setProfileMenuAnchor,
    guardedNavigate,
  } = useAppContext();
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    if (userData.User_Photo_Path !== null && userData.User_Photo_Path !== "") {
      setProfilePicture(userData.User_Photo_Path);
    } else {
      setProfilePicture(Person);
    }
  }, [userData]);

  return (
    <AppBar
      elevation={0}
      color="transparent"
      style={{
        display: "block",
        padding: 0,
        margin: 0,
        width: "100%",
      }}
    >
      <Toolbar
        style={{
          justifyContent: "space-between",
          height: "40px",
          minHeight: "55px",
          // position: "fixed",
          // top: 0,
          // left: 0,
          backgroundColor: isMobile ? "#7B7DE5" : "#ffffff",
          borderBottom: isMobile ? "none" : "1px solid #E0E0E0",
        }}
      >
        {isMobile && (
          <IconButton
            // edge="start"
            onClick={() => setDrawerOpen(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon style={{ color: "#fff" }} />
          </IconButton>
        )}
        {/* <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
                    Medical Assistant
                </Typography> */}

        {isMobile ? (
          <img src={LogoMobile} style={{ width: 110 }} />
        ) : (
          <img src={Logo} style={{ width: 160 }} />
        )}

        {/* <IconButton
          color="inherit"
        //   onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
            }}
          >
            <img src={profilePicture} width={32} height={32} />
          </Avatar>
        </IconButton> */}

        {isPhysician && (
          <Box display="flex" alignItems="center">
            <Button
              variant="outlined"
              title="Portal Guide" // basic HTML tooltip
              sx={{
                color: "primary.main",
                borderColor: "primary.main",
                marginRight: 1,
                borderRadius: 2,
                fontSize: 14,
                padding: "4px 8px",
                minWidth: "32px",
                height: "32px",
                minHeight: "32px",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "#fff",
                },
              }}
              onClick={(e) => guardedNavigate(navigate, "/physician/physician-guide")}
            >
              <QuestionMarkRoundedIcon sx={{ fontSize: "17px" }} />
            </Button>
            <IconButton onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
              <Avatar sx={{ width: 32, height: 32 }} src={profilePicture} />
            </IconButton>
          </Box>
        )}

        {isPatient && (
          <Box display="flex" alignItems="center">
            <Button
              variant="outlined"
              title="Portal Guide" // basic HTML tooltip
              sx={{
                color: "primary.main",
                borderColor: "primary.main",
                marginRight: 1,
                borderRadius: 2,
                fontSize: 14,
                padding: "4px 8px",
                minWidth: "32px",
                height: "32px",
                minHeight: "32px",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "#fff",
                },
              }}
              onClick={(e) => guardedNavigate(navigate, "/patient-guide")}
            >
              <QuestionMarkRoundedIcon sx={{ fontSize: "16px" }} />
            </Button>
            <IconButton onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
              <Avatar sx={{ width: 32, height: 32 }} src={profilePicture} />
            </IconButton>
          </Box>
        )}

        {isFacilities && (
          <Box display="flex" alignItems="center">
            <Button
              variant="outlined"
              title="Portal Guide" // basic HTML tooltip
              sx={{
                color: "primary.main",
                borderColor: "primary.main",
                marginRight: 1,
                borderRadius: 2,
                fontSize: 14,
                padding: "4px 8px",
                minWidth: "32px",
                height: "32px",
                minHeight: "32px",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "#fff",
                },
              }}
              onClick={(e) => guardedNavigate(navigate, "/facilities/guide")}
            >
              <QuestionMarkRoundedIcon sx={{ fontSize: "17px" }} />
            </Button>
            <IconButton onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
              <Avatar sx={{ width: 32, height: 32 }} src={profilePicture} />
            </IconButton>
          </Box>
        )}

        <Menu
          anchorEl={profileMenuAnchor}
          open={Boolean(profileMenuAnchor)}
          onClose={() => setProfileMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ fontSize: "14px", paddingX: "5px" }}
        >
          {/* Profile */}
          <MenuItem
            onClick={() => {
              guardedNavigate(navigate, roleRoutes[role]?.profile);
              setProfileMenuAnchor(null);
            }}
            sx={{ color: "text.secondary" }}
          >
            <PersonIcon sx={{ mr: 1 }} /> Profile
          </MenuItem>

          {/* Change Password (conditional) */}
          {roleRoutes[role]?.changePassword && (
            <MenuItem
              onClick={() => {
                guardedNavigate(navigate, roleRoutes[role]?.changePassword);
                setProfileMenuAnchor(null);
              }}
              sx={{ color: "text.secondary" }}
            >
              <LockIcon sx={{ mr: 1 }} /> Change Password
            </MenuItem>
          )}

          <Divider />

          {/* Logout */}
          <MenuItem
            onClick={() => {
              localStorage.clear();
              guardedNavigate(navigate, "/login");
            }}
            sx={{ color: "text.secondary" }}
          >
            <LogoutIcon sx={{ mr: 1 }} /> Logout
          </MenuItem>
        </Menu>

        {isAdmin && (
          <IconButton onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
              }}
              src={profilePicture}
            />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
};
export default Header;
